import type { HostOptions } from './contracts';
import { hostThemeBranding } from './config/theme';
import { useMemo } from 'react';
import { HostChatProvider } from './provider.tsx';
import { ChatThemeProvider } from '@/chat/ui/index.js';
import { resolveThemeTokens } from '../ui/theme/branding.js';
import { CHAT_UI_THEME_TOKENS } from '../ui/theme/themeTokens.js';
import { defaultSurfaceRegistry } from './surfaces.ts';
import { LocaleProvider } from '../ui/locale/provider';
import * as contextUsageFormatters from '../ui/locale/context-usage-labels.js';

export default function App(props: HostOptions = {}) {
  const { surface = 'standalone', surfaceRegistry = defaultSurfaceRegistry } = props;
  const Surface = surfaceRegistry.resolve(surface);
  const themeBranding = useMemo(() => hostThemeBranding(props.branding), [props.branding]);
  // A fixed host palette disables theme switching without changing the shared UI provider.
  const themeTokens = useMemo(() => resolveThemeTokens({
    baseTokens: CHAT_UI_THEME_TOKENS.light, branding: themeBranding, appearance: 'light',
  }), [themeBranding]);
  const options = useMemo(() => ({ contextUsageFormatters, ...props }), [props]);


  return <ChatThemeProvider appearance="light" themeTokens={themeTokens}>
    <LocaleProvider uiLabels={props.uiLabels}>
      <HostChatProvider options={options}><Surface {...props} /></HostChatProvider>
    </LocaleProvider>
  </ChatThemeProvider>;
}
